'use client';
import React from 'react';

import Comment from './Comment';
import Replies from './Replies';

interface CommentWithReplyProps {
  replies: WordpressComment[];
  content: string;
  post_id: number;
  date_gmt_iso: string;
  role: string[];
  user: string;
  user_id: number;
  id: number;
}

export default function CommentWithReply({ replies, ...props }: CommentWithReplyProps) {
  return (
    <>
      <Comment {...props} />
      <Replies replies={replies} />
    </>
  );
}
